import("./bootstrap").catch((error: unknown) => {
  console.error("Failed to load bootstrap:", error)
})
